<template>
  <div class="home_container" style="background-color: #111;">
    <div class="home">
      <!-- 头部 -->
      <navBar></navBar>
    </div>
    <div>
      <router-view />
    </div>
    <Footer v-show="isShowFooter"></Footer>
  </div>
</template>
<script setup>
import navBar from '@/components/navBar'
import Footer from '@/components/footer/footer.vue'
import {  watch ,ref} from 'vue'
import { useRoute } from 'vue-router'
const route = useRoute();
let isShowFooter = ref(false)
let whiteList = ['/home/find','/home/Solution','/home/resourceCenter','/home/about','/home/product', '/downloadApp']
watch(
  () => route.path,
  (val) => {
    console.log(val);
    if(whiteList.includes(val)){
      isShowFooter.value = true
    }else{
      isShowFooter.value = false
    }
  },
  { immediate: true }
)
</script>
<style scoped lang="scss">

</style>